export default [
    {
        id: 1,
        stringId: 'private',
        name: 'Private',
    },
    {
        id: 2,
        stringId: 'public',
        name: 'Public',
    },
    {
        id: 3,
        stringId: 'restricted',
        name: 'Restricted',
    },
    {
        id: 4,
        stringId: 'exclusive',
        name: 'Exclusive',
    },
    {
        id: 5,
        stringId: 'internal',
        name: 'Internal',
    },
];
